export const addCopyButtons = () => {
  const allCode = document.querySelectorAll("pre")
  if (allCode.length > 0) {
    allCode.forEach((item) => {
      item.setAttribute("data-before", "copy")
      item.addEventListener("click", (event) => {
        event.stopImmediatePropagation()
        if (event.target === item) {
          const code = item?.childNodes[0]?.innerHTML
          if (code) {
            navigator.clipboard.writeText(code)
            item.setAttribute("data-before", "copied")
            setTimeout(() => {
              item.setAttribute("data-before", "copy")
            }, 5000)
          }
        }
      })
    })
  }
}
